import { layout } from 'thewest/App.routing'
import { overrides } from 'component-library/feature-toggling/ExperimentalFeatures/experimental-features-list'
import { metrics } from 'component-library/__styling/settings'
import { StaticRoutes, createPageDefinition } from 'common/routing/page-definition'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

export const userOverridesRoute: StaticRoutes<typeof layout, TheWestSection> = {
    '/experimental-features': () =>
        createPageDefinition<typeof layout, TheWestSection>(
            {
                heading: 'Experimental Features',
                hideHeading: true,
                pageType: 'static',
                adTargeting: {
                    pageId: 'diag',
                    adUnitPath: '',
                    ssAdUnits: [],
                    topics: [],
                },
                section: 'default',
            },
            layout.composition({
                type: 'box',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    verticalGutters: ['outerMargin', 'unset'],
                    horizontalGutters: 'outerMargin',
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'breadcrumb',
                            props: {
                                title: 'Experimental Features',
                                enableHeaderTag: true,
                            },
                        }),
                    ],
                },
            }),
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: true,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'experimental-features',
                                        props: {
                                            featureDescriptions: overrides,
                                        },
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            })
        ),
}
